"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BasePatternFactory = _interopRequireDefault(require("../lib/BasePatternFactory"));

var _UrlRegex = _interopRequireDefault(require("../regex/UrlRegex"));

var _UrlWithProtocolRegex = _interopRequireDefault(require("../regex/UrlWithProtocolRegex"));

var _UrlRegexFactory = _interopRequireDefault(require("../regex/factories/UrlRegexFactory"));

var _UrlParts = _interopRequireDefault(require("../regex/parts/UrlParts"));

var _makeGlobalUrlRegex = function _makeGlobalUrlRegex() {
  return (0, _UrlRegexFactory.default)({
    isGlobal: true,
    search: _UrlParts.default.ungroupedSearch
  });
};

var UrlPattern = (0, _BasePatternFactory.default)({
  name: 'Url',
  validator: function validator(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (options && options.requireProtocol) {
      return _UrlWithProtocolRegex.default.test(input);
    }

    return _UrlRegex.default.test(input);
  }
});

UrlPattern.pick = function (input) {
  var GlobalUrlRegex = _makeGlobalUrlRegex();

  var results = [];
  var matchedGroups = GlobalUrlRegex.exec(input);

  while (matchedGroups !== null) {
    var start = matchedGroups.index;
    var end = start + matchedGroups[0].length - 1;
    results.push({
      start: start,
      end: end
    });
    matchedGroups = GlobalUrlRegex.exec(input);
  }

  return results;
};

var _default = UrlPattern;
exports.default = _default;
module.exports = exports.default;